import { createSelector, createFeatureSelector } from '@ngrx/store';

import {
  SalesOrderPeriod,
  SalesOrderPeriodState,
  TreatmentType,
} from '../models/sales-order-period.models';

export const selectSalesOrderPeriodState =
  createFeatureSelector<SalesOrderPeriodState>('salesOrderPeriod');

export const selectPastSalesOrderPeriods = createSelector(
  selectSalesOrderPeriodState,
  (store: SalesOrderPeriodState) => store?.pastSalesOrderPeriods || [],
);

export const selectSalesOrderPeriods = createSelector(
  selectSalesOrderPeriodState,
  (store: SalesOrderPeriodState) => store?.salesOrderPeriods || [],
);

export const selectSalesOrderPeriodsByType = ({ periodType }: { periodType: TreatmentType }) =>
  createSelector(selectSalesOrderPeriods, (salesOrderPeriods: SalesOrderPeriod[]) =>
    salesOrderPeriods.filter((salesOrderPeriod) => salesOrderPeriod.periodType === periodType),
  );

export const selectFertilizationSalesOrderPeriods = createSelector(
  selectSalesOrderPeriods,
  (salesOrderPeriods: SalesOrderPeriod[]) =>
    selectSalesOrderPeriodsByType({
      periodType: TreatmentType.Fertilization,
    }).projector(salesOrderPeriods),
);

export const selectPastSalesOrderPeriodsByType = ({ periodType }: { periodType: TreatmentType }) =>
  createSelector(selectPastSalesOrderPeriods, (salesOrderPeriods: SalesOrderPeriod[]) =>
    salesOrderPeriods.filter((salesOrderPeriod) => salesOrderPeriod.periodType === periodType),
  );
